import { arrayOf, bool, func, shape, string } from 'prop-types';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';

import DaysFromToday from '../../generic/DaysFromToday';

function MissingSKUsConfirmationDialog({
  linesPendingAcknowledgement,
  isOpen,
  onConfirm,
  onDismiss,
}) {
  return (
    <Modal isOpen={isOpen} toggle={onDismiss}>
      <ModalHeader toggle={onDismiss}>
        Push to the operative systems
      </ModalHeader>
      <ModalBody>
        The following campaign lines are <strong>missing SKUs</strong>:
        <ul>
          {linesPendingAcknowledgement.map(({ name, startDate }) => (
            <li key={name}>
              {name} (starting <DaysFromToday date={startDate} />)
            </li>
          ))}
        </ul>
        Please remember to add them in the operative system.
      </ModalBody>
      <ModalFooter className="justify-content-start">
        <Button onClick={onConfirm} color="primary">
          Push
        </Button>
        <Button onClick={onDismiss}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
}

MissingSKUsConfirmationDialog.propTypes = {
  linesPendingAcknowledgement: arrayOf(
    shape({
      name: string.isRequired,
      startDate: string.isRequired,
    }),
  ).isRequired,
  isOpen: bool.isRequired,
  onConfirm: func.isRequired,
  onDismiss: func.isRequired,
};

export default MissingSKUsConfirmationDialog;
